export const readCanvasImageFile = (
  file: File,
  onLoad: (
    canvas: HTMLCanvasElement,
    ctx: CanvasRenderingContext2D,
    img: HTMLImageElement,
  ) => void,
) => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  const reader = new FileReader();

  reader.onload = e => {
    const img = new Image();

    img.onload = () => {
      onLoad(canvas, ctx!, img);
    };

    img.src = e.target?.result as string;
  };

  reader.readAsDataURL(file);
};

export const cropImageFile = (
  file: File,
  coords: { x: number; y: number; width: number; height: number },
  onSuccess: (file: File) => void,
) => {
  const { x, y, width, height } = coords;

  readCanvasImageFile(file, (canvas, ctx, img) => {
    const imgWidth = img.width;
    const imgHeight = img.height;

    const cropX = x * imgWidth;
    const cropY = y * imgHeight;
    const cropWidth = width * imgWidth;
    const cropHeight = height * imgHeight;

    canvas.width = cropWidth;
    canvas.height = cropHeight;

    ctx!.drawImage(
      img,
      cropX,
      cropY,
      cropWidth,
      cropHeight,
      0,
      0,
      cropWidth,
      cropHeight,
    );

    canvas.toBlob(blob => {
      if (!blob) return;

      const newFile = new File([blob], file.name, { type: 'image/jpeg' });
      onSuccess(newFile);
    }, 'image/jpeg');
  });
};
